import React from 'react'
import "./Footer.css"
import { useSelector } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import phoneIcone from "../../assets/bxs_phone-call.svg"
import emailIcone from "../../assets/ic_sharp-email.svg"
import logo from "../../assets/logo.png"

function Footer({ scrollToSection }) {
      const { currentLocal } = useSelector((state) => state.currentLocal);
  const navigate = useNavigate();
  const location = useLocation();
    const path = location.pathname;
  const pathSegment = path.split('/').pop();
  const sendMail = () => {
    window.location.href = "mailto:example@example.com";
  };

  const makeCall = () => {
    window.location.href = "tel:+96895147494";
  };
  return (
    <footer>
      <div className="footer_container py-3">
      <Container>
        <div className="py-4 d-flex justify-content-center align-items-center ">
<div className="justify-content-center align-items-center w-50 d-flex">
            <img src={logo} alt=""className='w-25' />

</div>
        </div>
        <div className="py-4 ">
          <Row>
            <Col md={4}>
              <ul className="m-0">
                <li className="footer_title">{currentLocal.home.reachUs}</li>
                <li className="d-flex  align-items-center mt-4" onClick={makeCall}
                >
                  <img src={phoneIcone} alt="" />
                  <p className="mb-1 footer_item">+96895147494</p>
                </li>
                <li className="d-flex  align-items-center mt-3" onClick={sendMail}>
                  <img src={emailIcone} alt="" />
                  <p className="mb-1 footer_item">Contact@alaafaqschool.com</p>
                </li>

              </ul>
            </Col>
            <Col md={4}>
              <ul className="m-0 quickLinks">
                <li className="footer_title">{currentLocal.home.quickLinks}</li>
                <li className="footer_item" onClick={() =>  {
                  if (pathSegment === "login") {
                    navigate('/');


                  } else {
                    scrollToSection("home")
                  }
                }}>
                  <p className="mb-1">{currentLocal.home.home}</p>
                </li>
                      <li className="footer_item" onClick={() =>  {
                  if (pathSegment === "login") {
                    navigate('/');


                  } else {
                    scrollToSection("about")
                  }
                }
}>
                  <p className="mb-1">{currentLocal.home.aboutafaq}</p>
                </li>
                <li className="footer_item" onClick={() => {
                  if (pathSegment === "login") {
                    navigate('/');


                  } else {
                    scrollToSection("Features")
                  }
                }}>
                  <p className="mb-1">{currentLocal.home.features}</p>
                </li>
          
                <li className="footer_item" onClick={() => {
                  if (pathSegment === "login") {
                    navigate('/');


                  } else {
                                        navigate('/contact-us');

                  }
                }}>
                  <p className="mb-1 ">{currentLocal.home.contactUs}</p>
                </li>
              </ul>
            </Col>
            <Col md={4}>

            </Col>
          </Row>
        </div>
      </Container>
    </div>

    </footer>
  )
}

export default Footer